import { WatchDetailAttributes } from './watchDataAttributes';
import { CarDetailAttributes } from './carDataAttributes';
import { ComicDetailAttributes } from './comicDataAttributes';
import { OtherDetailAttributes } from './otherDataAttributes';
import { ArtDetailAttributes } from './artDataAttributes';
import { AntiqueDetailAttributes } from './antiqueDataAttributes';
import { BookDetailAttributes } from './bookDataAttributes';
import { CoinDetailAttributes } from './coinDataAttributes';
import { StampDetailAttributes } from './stampDataAttributes';
import { CameraDetailAttributes } from './cameraDataAttributes';
import { FirearmDetailAttributes } from './firearmDataAttributes';
import { HandbagDetailAttributes } from './handbagDataAttributes';
import { JewelryDetailAttributes } from './jewelryDataAttributes';
import { ToyDetailAttributes } from './toyDataAttributes';
import { HistoricalMemDetailAttributes } from './historicalMemorabiliaDataAttributes';
import { MovieMemDetailAttributes } from './movieMemorabiliaDataAttributes';
import { MusicalInstrumentDetailAttributes } from './musicalInstrumentDataAttributes';
import { MusicMemDetailAttributes } from './musicMemorabiliaDataAttributes';
import { SportsMemDetailAttributes } from './sportsMemorabiliaDataAttributes';
import { WineDetailAttributes } from './wineDataAttributes';
import { SportsCardDetailAttributes } from './sportsCardDataAttributes';
import { VinylRecordDetailAttributes } from './vinylRecordDataAttributes';

export default {

  details: {
    WATCH: WatchDetailAttributes,
    CAR: CarDetailAttributes,
    COMIC: ComicDetailAttributes,
    OTHER: OtherDetailAttributes,
    ART: ArtDetailAttributes,
    ANTIQUE: AntiqueDetailAttributes,
    BOOK: BookDetailAttributes,
    COIN: CoinDetailAttributes,
    STAMP: StampDetailAttributes,
    CAMERA: CameraDetailAttributes,
    FIREARM: FirearmDetailAttributes,
    HANDBAG: HandbagDetailAttributes,
    JEWELRY: JewelryDetailAttributes,
    TOY: ToyDetailAttributes,
    MUSICAL_MEM: MusicMemDetailAttributes,
    SPORTS_MEM: SportsMemDetailAttributes,
    HISTORIC_MEM: HistoricalMemDetailAttributes,
    MOVIE_MEM: MovieMemDetailAttributes,
    MUSICAL_INST: MusicalInstrumentDetailAttributes,
    WINE: WineDetailAttributes,
    SPORTS_CARD: SportsCardDetailAttributes,
    VINYL_RECORD: VinylRecordDetailAttributes,
  },
};



// WEBPACK FOOTER //
// ./src/config/details.js